import { IHolviAccount } from '@root/query/holvi'
import { TFunction } from 'i18next'
import { formatShortIBAN } from './iban'

export const getHolviAccountName = (
  accountName: string | undefined,
  accountType: string,
  t: TFunction
): string => {
  const defaultNamesByType = {
    psd: t('settings.holvi.account.psd'),
    credit: t('settings.holvi.account.credit')
  }
  return accountName ?? defaultNamesByType[accountType] ?? ''
}

export const getShortAccountIdentifier = (account: IHolviAccount, t: TFunction): string =>
  [formatShortIBAN(account.iban), getHolviAccountName(account.name, account.type, t)].join(' - ')
